import {
    CALCULATE_QUOTATION_FAIL,
    CALCULATE_QUOTATION_SUCCESS,
    CREATE_QUOTATION_FAIL,
    CREATE_QUOTATION_SUCCESS,
    UPDATE_QUOTATION_FAIL,
    UPDATE_QUOTATION_SUCCESS,
    DELETE_QUOTATION_FAIL,
    DELETE_QUOTATION_SUCCESS,
    GET_QUOTATION_DETAILS_FAIL,
    GET_QUOTATION_DETAILS_SUCCESS,
    GET_QUOTATION_FILTERS_FAIL,
    GET_QUOTATION_FILTERS_SUCCESS,
    GET_QUOTATION_LISTING_FAIL,
    GET_QUOTATION_LISTING_SUCCESS,
    RESET_QUOTATION_ACTION_STATE,
    SEND_QUOTATION_EMAIL_FAIL,
    SEND_QUOTATION_EMAIL_SUCCESS,
    SEND_QUOTATION_WHATSAPP_FAIL,
    SEND_QUOTATION_WHATSAPP_SUCCESS,
} from "./actionTypes"

const INIT_STATE = {
    quotationListing: [],
    quotationFilters: [],
    coeBiddingList: [],
    quotationDetails: [],
    quotationInterestRate: [],
    quotationAdd: [],
    quotationUpdate: [],
    quotationDelete: [],
    quotationCalculation: [],
    quotationEmail: [],
    quotationWhatsapp: [],
    error: [],
}

const Quotation = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_QUOTATION_LISTING_SUCCESS:
            return {
                ...state,
                quotationListing: action.payload
            }
        case GET_QUOTATION_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_QUOTATION_DETAILS_SUCCESS:
            return {
                ...state,
                quotationDetails: action.payload
            }
        case GET_QUOTATION_DETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
                quotationDetails: action.payload,
            }

        case CREATE_QUOTATION_SUCCESS:
            return {
                ...state,
                quotationAdd: action.payload
            }
        case CREATE_QUOTATION_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case DELETE_QUOTATION_SUCCESS:
            return {
                ...state,
                quotationDelete: action.payload
            }
        case DELETE_QUOTATION_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_QUOTATION_FILTERS_SUCCESS:
            return { ...state, quotationFilters: action.payload }
        case GET_QUOTATION_FILTERS_FAIL:
            return { ...state, error: action.payload }

        case UPDATE_QUOTATION_SUCCESS:
            return { ...state, quotationUpdate: action.payload }
        case UPDATE_QUOTATION_FAIL:
            return { ...state, error: action.payload }
        case CALCULATE_QUOTATION_SUCCESS:
            return { ...state, quotationCalculation: action.payload }
        case CALCULATE_QUOTATION_FAIL:
            return { ...state, error: action.payload }
        case SEND_QUOTATION_EMAIL_SUCCESS:
            return { ...state, quotationEmail: action.payload }
        case SEND_QUOTATION_EMAIL_FAIL:
            return { ...state, error: action.payload }
        case SEND_QUOTATION_WHATSAPP_SUCCESS:
            return { ...state, quotationWhatsapp: action.payload }
        case SEND_QUOTATION_WHATSAPP_FAIL:
            return { ...state, error: action.payload }

        case RESET_QUOTATION_ACTION_STATE:
            return {
                ...state,
                quotationAdd: [],
                quotationUpdate: [],
                quotationDelete: [],
                quotationInterestRate: [],
                quotationCalculation: [],
                quotationEmail: [],
                quotationWhatsapp: [],
                error: [],
            }

        default:
            return state
    }
}

export default Quotation
